import React, { useState } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import { ProcessusLog } from '../../../models/processusLog';

export default function TableLine(props: { row: ProcessusLog }) {
	const { row } = props;
	const momentDate = moment(row.date);
	const formatedDate = momentDate.format('DD/MM/YYYY HH:mm:ss');
	const [open, setOpen] = useState(false);

	const handleOpen = () => setOpen(true);

	const handleClose = () => setOpen(false);

	return (
		<TableRow sx={{ height: 45 }}>
			<TableCell>{formatedDate}</TableCell>
			<TableCell>{row.process.name}</TableCell>
			<TableCell>{row.message}</TableCell>
			<TableCell style={{ color: '#' + row.status.color.color }}>{row.status.name}</TableCell>
			<TableCell>
				{row.errorStack !== '' && <Button onClick={handleOpen}>Ouvrir le log</Button>}

				<Modal
					open={open}
					onClose={handleClose}
					disablePortal
					disableEnforceFocus
					disableAutoFocus
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
					sx={{
						display: 'flex',
						p: 1,
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Box
						sx={{
							position: 'relative',
							width: 800,
							bgcolor: 'background.paper',
							boxShadow: (theme) => theme.shadows[5],
							p: 4,
						}}
					>
						<Box>
							<Typography id="modal-modal-title" variant="h6" component="h2">
								{row.message}
							</Typography>
							<Typography id="modal-modal-description" sx={{ mt: 2 }}>
								{row.errorStack}
							</Typography>
						</Box>
					</Box>
				</Modal>
			</TableCell>
		</TableRow>
	);
}
